import { atom } from 'jotai';
import {
  type ResolvedBrandingUI,
  type ExtendedResolvedBrandingUI,
  defaultResolvedBrandingUI,
} from '@/lib/types/branding';

/**
 * Purpose: Stores the resolved branding UI settings for the currently active community or platform default.
 * Location: src/lib/state/brandingAtoms.ts
 * Initial Value: defaultResolvedBrandingUI from '@/lib/types/branding'.
 * Note: Now supports both basic and extended branding types for Brand.dev integration
 */
export const currentBrandingAtom = atom<ResolvedBrandingUI | ExtendedResolvedBrandingUI>(
  defaultResolvedBrandingUI
);

/**
 * Purpose: Stores the loading state for branding information.
 * Location: src/lib/state/brandingAtoms.ts
 * Initial Value: true, assuming branding will be fetched on initial load.
 */
export const isBrandingLoadingAtom = atom<boolean>(true);

/**
 * Purpose: Stores any error that occurred while fetching branding information.
 * Location: src/lib/state/brandingAtoms.ts
 * Initial Value: null.
 */
export const brandingErrorAtom = atom<Error | null>(null);

/**
 * Purpose: Stores the determined hostname, used to fetch branding.
 * Location: src/lib/state/brandingAtoms.ts
 * Initial Value: null. Can be set by the useBranding hook.
 */
export const currentHostnameAtom = atom<string | null>(null);
